
import {
    Accordion, AccordionHeader, AccordionItem,
    AccordionPanel, Button, Divider,
    Field, Input, InputProps, Table,
    TableCell, TableColumnDefinition,
    TableHeader, TableHeaderCell,
    TableRow, TableSelectionCell,
    Tooltip, createTableColumn,
    makeStyles, useTableFeatures, useTableSelection

} from "@fluentui/react-components";

import {
    DrawerBody,
    DrawerHeader,
    DrawerHeaderTitle,
    Drawer,
} from "@fluentui/react-components/unstable";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { useContext, useEffect, useState } from "react";
import { Extract, Master } from "../library/CosmeWidgetAPIClient";
import PageLoading from "./PageLoading";
import AddMasterCard from "./AddMasterCard";
import { CWClientContext } from "../App";



const useStyles = makeStyles({
    searchArea: {
        display: "flex",
    },
});

type MasterSearchDrawerProp = {
    extract: Extract,
    buttonIcon: JSX.Element,
    tooltipContent: JSX.Element,
    updateCallback: (maker: string,
        brand: string,
        item: string,
        color: string,
        masterId: string) => void,
}

const MasterSearchDrawer = (prop: MasterSearchDrawerProp) => {
    const extract = prop.extract;
    // const styles = useStyles();
    const cwClient = useContext(CWClientContext);
    const [isOpen, setIsOpen] = useState(false);
    const [masters, setMasters] = useState<Master[]>();
    const [word, setWord] = useState<string>();
    const [isSearch, setIsSearch] = useState(false);
    let defaultValue = "";

    const setDefaultValue = () => {
        if (extract.maker != null && extract.maker != null && !extract.maker.match(/検出/)) {
            defaultValue += extract.maker + " ";
        }
        if (extract.brand != null && extract.brand != null && !extract.brand.match(/検出/)) {
            defaultValue += extract.brand + " ";
        }
        if (extract.item != null && extract.item != null && !extract.item.match(/検出/)) {
            defaultValue += extract.item + " ";
        }
        if (extract.color != null && extract.color != null && !extract.color.match(/検出/)) {
            defaultValue += extract.color + " ";
        }
    }

    const search = () => {
        console.log("call - search function. isSearch is : " + isSearch);
        if (!isSearch) {
            setIsSearch(true);
            setMasters(undefined);
            if (word === undefined || word === "") {
                setIsSearch(false);
                console.log("abort - search function. word is undefined.")
                setMasters([] as Master[]);
                return;
            }
            console.log("Searching ... " + word);
            cwClient.searchMaster(word).then((m) => {
                console.log("search result : ", m);
                setMasters(m);
                setIsSearch(false);
            });
            // (async () => {
            //     let m = await cwClient.searchMaster(word);
            //     console.log("search result : ", m);
            //     setMasters(m);
            //     setIsSearch(false);
            // })();
        }
    }


    const searchOnChange: InputProps["onChange"] = (ev, data) => {
        console.log("searchOnChange : " ,data   )
        if (data !== undefined) {
            console.log("searchOnChange(data != undefined)  : " ,data.value);
            setWord(data.value);
            search();
        }
    }

    const columns: TableColumnDefinition<Master>[] = [
        createTableColumn<Master>({
            columnId: "maker",
        }),
        createTableColumn<Master>({
            columnId: "brand",
        }),
        createTableColumn<Master>({
            columnId: "item",
        }),
        createTableColumn<Master>({
            columnId: "color",
        }),
    ];

    const {
        getRows,
        selection: { toggleRow, isRowSelected },
    } = useTableFeatures<Master>(
        {
            columns: columns,
            items: (masters !== undefined) ? masters : [] as Master[],
        },
        [
            useTableSelection({
                selectionMode: "single",
                defaultSelectedItems: new Set([0]),
            }),
        ]
    );

    const rows = getRows((row) => {
        const selected = isRowSelected(row.rowId);
        return {
            ...row,
            onClick: (e: React.MouseEvent) => toggleRow(e, row.rowId),
            onDoubleClick: (e: React.MouseEvent) => {
                // TODO: Extractに反映
                console.log(row.item);
                prop.updateCallback(row.item.maker, row.item.brand, row.item.item, row.item.color, row.item.id);
                setIsOpen(false);
            },
            onKeyDown: (e: React.KeyboardEvent) => {
                if (e.key === " ") {
                    e.preventDefault();
                    toggleRow(e, row.rowId);
                }
            },
            selected,
            appearance: selected ? ("brand" as const) : ("none" as const),
        };
    });

    const masterView = () => {
        if (masters === undefined) {
            return (
                <PageLoading
                    message="元帳の情報を取得しています。"
                />
            )
        } else {
            if (masters.length === 0) {
                return (
                    <>

                        <div>
                            見つかりませんでした
                        </div>
                    </>
                )
            } else {
                return (
                    <>
                        <div>
                            <Table>
                                <TableHeader>
                                    <TableRow>
                                        <TableSelectionCell type="radio" hidden />
                                        <TableHeaderCell>メーカー</TableHeaderCell>
                                        <TableHeaderCell>ブランド</TableHeaderCell>
                                        <TableHeaderCell>商品名</TableHeaderCell>
                                        <TableHeaderCell>色</TableHeaderCell>

                                    </TableRow>
                                </TableHeader>

                                {rows.map(({ item, selected, onClick, onDoubleClick, onKeyDown, appearance }) => {
                                    return (
                                        <>
                                            <TableRow
                                                key={item.id}
                                                onClick={onClick}
                                                onDoubleClick={onDoubleClick}
                                                onKeyDown={onKeyDown}
                                                aria-selected={selected}
                                                appearance={appearance}
                                            >
                                                <TableSelectionCell
                                                    checked={selected}
                                                    type="radio"
                                                    radioIndicator={{ "aria-label": "Select row" }}
                                                />

                                                <TableCell>{item.maker}</TableCell>
                                                <TableCell>{item.brand}</TableCell>
                                                <TableCell>{item.item}</TableCell>
                                                <TableCell>{item.color}</TableCell>
                                            </TableRow>
                                        </>
                                    )
                                })}
                            </Table>
                        </div>
                    </>
                )

            }
        }
    }

    // useEffect(() => {
    //     console.log("useEffect - bind mount.", defaultValue);
    //     setWord(defaultValue);
    //     // search();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    useEffect(() => {
        console.log("useEffect - bind isOpen", isOpen);
        if (isOpen === true) {
            setDefaultValue();
            setWord(defaultValue);
            console.log("defaultValue = ", defaultValue);
            search();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    return (
        <>
            <Tooltip content="元帳から探す"
                relationship="label"
            >
                <Button
                    icon={prop.buttonIcon}
                    appearance="subtle"
                    aria-label="元帳から探す"
                    onClick={() => {
                        setIsOpen(true);
                    }}
                />
            </Tooltip>
            <Drawer
                open={isOpen}
                type="overlay"
                size="medium"
            >
                <DrawerHeader>
                    <DrawerHeaderTitle
                        action={
                            <Button
                                appearance="subtle"
                                aria-label="Close"
                                icon={<Dismiss24Regular />}
                                onClick={() => setIsOpen(false)}
                            />
                        }
                    >
                        商品元帳検索
                    </DrawerHeaderTitle>
                </DrawerHeader>
                <DrawerBody>
                    <Field
                        label="メーカー名、ブランド名、商品名など"
                    >
                        <Input
                            defaultValue={
                                defaultValue
                            }
                            value={
                                word
                            }
                            onChange={searchOnChange}
                        />
                    </Field>
                    <Accordion collapsible>
                        <AccordionItem
                            value="1"
                        >
                            <AccordionHeader>元帳に追加</AccordionHeader>
                            <AccordionPanel>
                                <AddMasterCard
                                    maker={extract.maker}
                                    brand={extract.brand}
                                    brandYomi={extract.brand}
                                    item={extract.item}
                                    color={extract.color}
                                    onAddMaster={(maker, brand, item, color) => {
                                        setWord(maker + ' ' + brand + ' ' + item + ' ' + color);
                                    }}
                                />

                            </AccordionPanel>
                        </AccordionItem>
                    </Accordion>
                    <Divider />
                    {masterView()}
                </DrawerBody>
            </Drawer>
        </>
    );
}

export default MasterSearchDrawer;